import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import StandardHeader from './StandardHeader';
import { Helmet } from 'react-helmet';
import CashSaverHeader from './CashSaverHeader';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

interface ITVLayoutProps {
  showHeader?: boolean;
  isEmbeddedInAndroid?: boolean;
  onClose?: () => void;
}

const ITVLayout: React.FC<PropsWithChildren<ITVLayoutProps>> = ({
  children,
  showHeader = true,
  isEmbeddedInAndroid,
  onClose,
}) => {
  const renderHeader = () => {
    if (isEmbeddedInAndroid) {
      return <CashSaverHeader onClose={onClose} />;
    }

    return <StandardHeader />;
  };

  return (
    <>
      <Helmet>
        <title>Kindred x itv</title>
        <link
          id="favicon"
          rel="icon"
          href="/itv-favicon.png"
          type="image/x-icon"
        />
      </Helmet>
      <Container>
        {showHeader && renderHeader()}
        {children}
      </Container>
    </>
  );
};

export default ITVLayout;
